import { render, staticRenderFns } from "./Turnstile.vue?vue&type=template&id=ee916bb4&scoped=true&"
import script from "./Turnstile.vue?vue&type=script&lang=ts&"
export * from "./Turnstile.vue?vue&type=script&lang=ts&"
import style0 from "./Turnstile.vue?vue&type=style&index=0&id=ee916bb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee916bb4",
  null
  
)

export default component.exports